import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "@/services/axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

const mutateUpdateBomUser = async ({
  data,
  id,
}: {
  data: FieldValues;
  id: string;
}) => {
  return await axiosAuth.put(`${BOM_USERS_API}/${id}`, data);
};

const useUpdateBomUserMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateBomUser,
    ...queryParams,
  });

export default useUpdateBomUserMutation;
